import { EntityRequestRwdacct } from "../../entity/EntityRequestRwdacct";

export class DtoRequestRwdacctsDeleteRes extends EntityRequestRwdacct {
  public message: string | null = null;
}
